export default __webpack_public_path__ + "static/media/Sort.5a88d708.svg";